<template>
  <ProductOffers :config="config" />
</template>

<script>

export default {
  name: 'SavingsProducts',
  components: {
    ProductOffers: () => import('@/views/products/ProductOffers.vue')
  },
  data () {
    return {
      config: {
        accountType: 'SVGS'
      }
    }
  }
}
</script>
